import { createContext, useContext, useRef, useState, type ComponentProps, type ReactNode } from 'react'
import { Search } from 'lucide-react'
import { createPortal } from 'react-dom'
import { useViewActive } from '../viewActivity'
import { IconButton } from './ui'
import { IconTooltip } from './IconTooltip'

export const WorkspaceHeaderContext = createContext<HTMLDivElement | null>(null)

/** Keep page actions with their view's state while placing them in the window header. */
export function WorkspaceActions({ children }: { children: ReactNode }) {
  const header = useContext(WorkspaceHeaderContext)
  const active = useViewActive()
  return header && active ? createPortal(children, header) : null
}

export function WorkspaceAction({ label, ...props }: ComponentProps<typeof IconButton>) {
  return <IconTooltip label={label} side="bottom"><IconButton type="button" {...props} label={label} className="icon-button workspace-header-action" /></IconTooltip>
}

export function WorkspaceSearch({ value, onChange, label, inputLabel = 'Search assets' }: { value: string; onChange: (value: string) => void; label: string; inputLabel?: string }) {
  const [open, setOpen] = useState(false)
  const button = useRef<HTMLButtonElement>(null)
  function close() { onChange(''); setOpen(false); button.current?.focus() }
  return <div className="review-header-tools"><div className={`review-header-search ${open ? 'is-expanded' : ''}`}>
    <IconTooltip label={open ? 'Close search' : label} side="bottom"><button ref={button} type="button" className="review-search-toggle" aria-label={open ? 'Close search' : label} aria-expanded={open} onClick={() => open ? close() : setOpen(true)}><Search size={18} /></button></IconTooltip>
    {open ? <input autoFocus type="search" aria-label={inputLabel} placeholder="Search assets" value={value} onChange={event => onChange(event.target.value)} onKeyDown={event => { if (event.key === 'Escape') { event.preventDefault(); close() } }} onBlur={event => { if (!value && event.relatedTarget !== button.current) setOpen(false) }} /> : null}
  </div></div>
}
